var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.getList),function(ref,idx){
var colData = ref[0];
var label = ref[1];
return _c('div',{key:colData,staticClass:"d-grid mt-1"},[_c('el-switch',{class:_vm.fieldType,attrs:{"active-color":"#270E66","active-text":_vm.$i18n.t(label),"value":_vm.isChecked(colData),"id":(_vm.fieldNameProp + "-" + idx + "-choicelist")},on:{"change":function($event){_vm.onChange(colData)}}}),_vm._v(" "),_vm._t("aggregation",null,{colData:colData})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }